module.exports = __webpack_public_path__ + "static/favicon-af32c53174beb29b383bb995f17459de.png";